import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Collapse, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import moment from 'moment';
import * as types from '../../constants/prayerFeatureActionTypes';
import * as consts from '../../constants/prayerFeatureConstants';
import CommentCard from './CommentCard';
import CommentForm from './CommentForm';
import YesNoModal from "../common/YesNoComponent";

function PrayerCard({ prayer, memberId, userRole, prayerCommentsMaxLimit,
    deletePrayer, addPrayerReaction, removePrayerReaction, getComments, getAllPrayers, onEdit, onActionComplete
}) {
    const [deletingPrayer, setDeletingPrayer] = useState(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [showComments, setShowComments] = useState(false);
    const [allComments, setAllComments] = useState(null);

    let data = null;
    let _liveObject = null;
    let _updateCount = 0;

    try {
        data = prayer && prayer.data && JSON.parse(prayer.data.text);
        if (data === null) {
            data = prayer.data.text;
        }
    } catch (ex) {
        //console.error(ex);
        if (data === null) {
            data = prayer.data.text;
        }
    }

    const timeCreatedAt = prayer.editedAt;
    const createdDateInMiliSec = new Date(timeCreatedAt).getTime();
    const createdTime = moment(timeCreatedAt).format('LL');
    const relativeCreatedTime = moment(timeCreatedAt).fromNow();

    useEffect(() => {

        return () => {
            if (_liveObject) {
                _liveObject.dispose();
            }
        };
    }, []);

    const _deletePrayer = (prayer) => {
        deletePrayer(prayer, success => {
            onActionComplete(success ?
                { success, confirmationMessage: consts.DELETE_POST_SUCCESS } :
                { success, confirmationMessage: consts.DELETE_POST_ERROR },
                !success
            );
        });
        setDeletingPrayer(null);
    };

    const reactionCallback = success => {
        if (!success) {
            onActionComplete({ success, confirmationMessage: consts.ACTION_ERROR }, true);
        }
        //    else {
        //        getAllPrayers();
        //    }
    };

    const handlePrayerReaction = (postId) => {
        if (!prayer.myReactions.includes("love")) {
            addPrayerReaction(postId, reactionCallback);
        }
        else {
            removePrayerReaction(postId, reactionCallback);
        }
    };

    const updateComments = (comments, sort) => {
        if (/*sort && */comments) {
            comments = comments.sort((a, b) => a.createdAt < b.createdAt ? -1 : 0);
        }
        const commentIds = comments.map(comment => comment.commentId);
        setAllComments(commentIds);
        getAllPrayers();
    }

    const _getComments = (sort) => {
        getComments(prayer.postId, liveObject => {
            if (_liveObject === null && liveObject) {
                _liveObject = liveObject;
                if (_liveObject.models) {
                    updateComments(_liveObject.models, sort);
                }
                if (_updateCount === 0) {
                    _liveObject.on('dataUpdated', comments => {
                        _updateCount++;
                        updateComments(comments, sort);
                        if (_updateCount > 1) {
                            _liveObject.dispose();
                            _updateCount = 0;
                        }
                    });
                }
            }
        });
    }

    const onCommentActionComplete = response => {
        if (response.success) {
            _getComments(true);
        }
        onActionComplete(response);
    }

    const showHideComments = () => {
        if (allComments === null) {
            if (prayer.commentsCount > prayer.comments.length) {
                _getComments();
            }
            else {
                setAllComments(prayer.comments);
            }
        }
        setShowComments(!showComments);
    };

    const toggle = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const timeDifference = (current, previous) => {
        const elapsed = current - previous;
        const hours = Math.round(elapsed / (60 * 60 * 1000));
        return `${hours <= 1 ? 'Just Now' : hours + ' Hours Ago'}`;
    };

    const isCreatedHoursAgo = (dates, hours) => {
        const fourtyEightHr = 1000 * 60 * 60 * hours;
        const fourtyEightHrAgo = Date.now() - fourtyEightHr;
        return dates > fourtyEightHrAgo;
    };

    const timeAgo = (isCreatedHoursAgo, createdDateInMiliSec, relativeCreatedTime, createdTime, currentTime) => {
        /*if (isCreatedHoursAgo(createdDateInMiliSec, 1)) {
            return relativeCreatedTime;
        } else*/ if (isCreatedHoursAgo(createdDateInMiliSec, 24)) {
            return timeDifference(currentTime, createdDateInMiliSec);
        } else if (isCreatedHoursAgo(createdDateInMiliSec, 48)) {
            return 'Yesterday';
        } else {
            return createdTime;
        }
    };

    const timeCreated = timeAgo(isCreatedHoursAgo, createdDateInMiliSec, relativeCreatedTime, createdTime, Date.now());

    if (!data) return;

    return (
        <>
            <div className={memberId === prayer.postedUserId
                ? 'prayer-card prayer-card-author'
                : 'prayer-card'} >
                <div className="prayer-card-header d-flex">
                    <div className="prayer-timestamp">{timeCreated}{prayer.createdAt.toString() !== prayer.editedAt.toString() && <span> &#8231; Edited</span>}</div>
                    <div className="prayer-topics-block">
                        {typeof data.topics === 'object' && data.topics.join(' ').length > 0 && (
                            <div className="prayer-topics">{typeof data.topics === 'object' ? data.topics.join(' ') : data.topics || ''}</div>
                        )}
                        {deletingPrayer &&
                            <YesNoModal showModal={deletingPrayer !== null} modalText={consts.DELETE_POST_CONFIRM}
                                modalNoFunction={() => setDeletingPrayer(null)} modalYesFunction={_deletePrayer} YesParameter={deletingPrayer}
                            />
                        }
                    </div>
                    {memberId === prayer.postedUserId && (
                        <Dropdown className="prayer-options d-flex" isOpen={dropdownOpen} toggle={toggle} direction="left">
                            <DropdownToggle>
                                <span className="icon-share-outline" />
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem onClick={() => onEdit({ ...data, postId: prayer.postId })} tag="button">
                                    Edit
                                </DropdownItem>
                                <DropdownItem onClick={() => setDeletingPrayer(prayer)} tag="button">
                                    Remove
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    )}
                </div>

                <div className="prayer-card-body">
                    <div className="prayer-card-title">{typeof data.title === 'object' ? data.title.join(' ') : data.title || ''}</div>
                    <div className="prayer-card-text">{typeof data.text === 'object' ? data.text.join(' ') : data.text || (typeof data === 'string' ? data : '')}</div>
                </div>

                <div className="prayer-card-footer d-flex justify-content-between">
                    {/* Reactions */}
                    <div className="d-flex prayer-card-reactions"
                        onClick={() => handlePrayerReaction(prayer.postId)}
                    >
                        <div className={prayer.myReactions.includes('love') ? 'svg-reaction-red-heart' : 'svg-reaction-white-heart'} />
                        <div className="reactions-count">{prayer.reactionsCount}</div>
                    </div>

                    {/* Updates (comments) counts */}
                    <div>
                        {prayer.commentsCount > 0 && (
                            <div className="prayer-updates" onClick={showHideComments}>
                                {prayer.commentsCount < prayerCommentsMaxLimit ? prayer.commentsCount : prayerCommentsMaxLimit}
                                {` Update${prayer.commentsCount === 1 ? ' ' : 's '}`}
                                <span className={showComments ? 'icon-dd-up' : 'icon-dd'} />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Prayer Comment cards */}
            {prayer.commentsCount > 0 &&
                <Collapse isOpen={showComments}>
                    <div className="prayer-comments-container">
                        {allComments && allComments.map(
                            commentId => <CommentCard key={commentId} memberId={memberId} commentId={commentId} postId={prayer.postId} onEdit={onEdit} onActionComplete={onCommentActionComplete} />
                        )}
                    </div>
                </Collapse>
            }

            {/* Comment form */}
            {(memberId === prayer.postedUserId || userRole === 'moderator') &&
                <CommentForm memberId={memberId} prayer={prayer} onActionComplete={onCommentActionComplete} />
            }
        </>
    );
}

const mapStateToProps = state => {
    return {
        userRole: state.prayerFeature.userRole,
        prayerCommentsMaxLimit: state.session.serverData.prayerCommentsMaxLimit
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getAllPrayers: callback => dispatch({ type: types.GET_ALL_PRAYERS, callback }),
        deletePrayer: (prayer, callback) => {
            dispatch({ type: types.DELETE_PRAYER, prayer, callback });
        },
        addPrayerReaction: (postId, callback) => {
            dispatch({ type: types.ADD_PRAYER_REACTION, postId, callback })
        },
        removePrayerReaction: (postId, callback) => {
            dispatch({ type: types.REMOVE_PRAYER_REACTION, postId, callback })
        },
        getComments: (postId, callback) => dispatch({ type: types.GET_COMMENTS, postId, callback })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrayerCard);